<app-progress></app-progress>
<div class="mat-typography">
    <mat-card class="m-8">
    <mat-card-header>
      <mat-card-title>
        <span>{{dataSource && dataSource.data ? (dataSource.data.length | i18nPlural: userPluralMapping) : '0 Users'}}</span>
        <span style="margin-left: 10px;"><button (click)="downloadCsv()" mat-raised-button color="primary">Export CSV</button></span>
        <span class="float-right">
          @if (admin) {
            <button [routerLink]="['/users/add/']" color="primary" mat-raised-button style="margin-bottom: 10px;"><i
            class="material-icons">add</i> Create new user</button>
          }
        </span>
      </mat-card-title>
    </mat-card-header>
    <div class="table mat-elevation-z8">
      @if (generalErrorMessage) {
        <mat-error>
          {{generalErrorMessage}}
        </mat-error>
      }
      <table [dataSource]="dataSource" class="table-responsive" mat-table matSort [matSortDisableClear]="true">
        <ng-container matColumnDef="email">
          <th *matHeaderCellDef mat-header-cell>Email</th>
          <td *matCellDef="let row" mat-cell>{{row.email}}</td>
        </ng-container>
        <ng-container matColumnDef="role">
          <th *matHeaderCellDef mat-header-cell>Role</th>
          <td *matCellDef="let row"
          mat-cell>{{row.admin ? 'Admin' : row.operator ? 'Operator-Employee' : 'Customer User'}}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef class="column-divide" mat-header-cell>@if (admin) {
            <span>Actions</span>
          }</th>
          <td *matCellDef="let row" mat-cell>
              <div class="flex items-center gap-2">
            @if (admin) {
              <button [routerLink]="['/users/edit/', row.id]" class="mat-elevation-z0" color="warn"
                mat-mini-fab
                title="Edit"><i class="material-icons">edit</i></button>
              }
              @if (admin) {
                <button (click)="deleteUser(row)" class="mat-elevation-z0" color="warn" mat-mini-fab
                  title="Delete"><i class="material-icons">delete_forever</i></button>
                }
              </div>
              </td>
            </ng-container>
            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
          </table>
        </div>
      </mat-card>
    </div>
